export default "__VITE_ASSET__DPLsJacW__"